import styled, { css } from 'styled-components';
import { ToolTipPosition } from './Tooltip';

export const TooltipContent = styled.div<{
  position: ToolTipPosition;
  shouldGrowCentered: boolean;
}>`
  ${({ shouldGrowCentered }) =>
    shouldGrowCentered &&
    css`
      align-items: center;
    `}
  background-color: ${({ theme }) => theme.tooltip.background};
  border-radius: 10px;
  color: ${({ theme }) => theme.tooltip.color};
  display: none;
  font-size: 14px;
  height: fit-content;
  line-height: ${({ theme }) => `${theme.tooltip.lineHeight}px`};
  min-height: fit-content;
  opacity: 0;
  padding: 0.75rem 1rem;
  position: fixed;
  transition: opacity 200ms;
  white-space: pre-line;
  width: max-content;
  z-index: ${({ theme }) => theme.layers.topLayer};

  ${({ position }) => {
    switch (position) {
      case ToolTipPosition.top:
        return css`
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
        `;
      case ToolTipPosition.bottom:
        return css`
          left: 50%;
          top: 100%;
          transform: translateX(-50%);
        `;
      default:
        return css``;
    }
  }}
`;

export const TooltipArrow = styled.div<{
  position: ToolTipPosition;
  shouldGrowDown: boolean;
  shouldGrowUp: boolean;
}>`
  background-color: ${({ theme }) => theme.tooltip.background};
  border-radius: 2px;
  height: 10px;
  position: absolute;
  transform: rotate(45deg);
  width: 10px;
  ${({ shouldGrowDown }) =>
    shouldGrowDown &&
    css`
      top: 12px;
    `}

  ${({ shouldGrowUp }) =>
    shouldGrowUp &&
    css`
      bottom: 12px;
    `}

  ${({ position }) => {
    switch (position) {
      case ToolTipPosition.top:
        return css`
          bottom: -8px;
          left: 50%;
          transform: rotate(45deg) translateX(-50%);
        `;
      case ToolTipPosition.right:
      case ToolTipPosition.bottomRight:
      case ToolTipPosition.topRight:
        return css`
          left: -4.5px;
        `;
      case ToolTipPosition.bottom:
        return css`
          left: 50%;
          top: 0px;
          transform: rotate(45deg) translateX(-50%);
        `;
      case ToolTipPosition.left:
      case ToolTipPosition.bottomLeft:
      case ToolTipPosition.topLeft:
        return css`
          right: -4.5px;
        `;
      default:
        return css``;
    }
  }}
`;

export const TooltipMessage = styled.p<{
  centered: boolean;
}>`
  margin: 0;
  text-align: ${({ centered }) => (centered ? 'center' : 'left')};
`;

export const TooltipContainer = styled.div<{
  disabled: boolean;
  isMobile: boolean;
  isOpen: boolean;
}>`
  align-items: center;
  display: flex;
  overflow: visible;

  ${({ disabled, isMobile, isOpen }) =>
    !disabled &&
    (!isMobile
      ? css`
          &:hover + ${TooltipContent} {
            display: flex;
            opacity: 1;
          }
        `
      : isOpen &&
        css`
          & + ${TooltipContent} {
            display: flex;
            opacity: 1;
          }
        `)}
`;
